import React from "react";
import {
  Avatar,
  Button,
  Separator,
  DropdownMenu,
  SmartTooltip,
} from "../../../../components";

const DropdownMenuList = () => {
  return (
    <div>
      <div className="flex items-center gap-5">
        <DropdownMenu
          MenuSection={
            <div className="flex flex-col">
              <Button
                title={"Option 1"}
                variant="text"
                color="black"
                size="xs-sm"
                className="!justify-start py-1"
              />
              <Button
                title={"Option 2"}
                variant="text"
                color="black"
                size="xs-sm"
                className="!justify-start py-1"
              />
            </div>
          }
        >
          <Button title={"Menu"} variant="outlined" color="black" />
        </DropdownMenu>
        <DropdownMenu
          MenuSection={
            <div className="flex flex-col">
              <Button
                title={"Option 1"}
                variant="text"
                color="black"
                size="xs-sm"
                className="!justify-start py-1"
              />
              <Button
                title={"Option 2"}
                variant="text"
                color="black"
                size="xs-sm"
                className="!justify-start py-1"
              />
            </div>
          }
        >
          <SmartTooltip description={"Menu"} variant="text" noicon noTooltip>
            <Button
              type="icon"
              size="xs-sm"
              icon={"east"}
              variant="outlined"
              color="black"
            />
          </SmartTooltip>
        </DropdownMenu>
        <DropdownMenu
          MenuSection={
            <div className="flex flex-col">
              <Button
                title={"Option 1"}
                variant="text"
                color="black"
                size="xs-sm"
                className="!justify-start py-1"
              />
              <Button
                title={"Option 2"}
                variant="text"
                color="black"
                size="xs-sm"
                className="!justify-start py-1"
              />
            </div>
          }
        >
          <SmartTooltip description={"Menu"} variant="text" noicon noTooltip>
            <Avatar size="sm" />
          </SmartTooltip>
        </DropdownMenu>
        <SmartTooltip description={"Meni"}>
          <Avatar size="sm" />
        </SmartTooltip>
      </div>
    </div>
  );
};

export default DropdownMenuList;
